import { useEffect } from "react";
const Reviews = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://elfsightcdn.com/platform.js";
    script.async = true;
    document.body.appendChild(script);
    return () => script.remove();
  }, []);

  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div
    className="elfsight-app-87f8c95a-ec3e-4c81-a0ee-8547d4ecd715"
    data-elfsight-app-lazy=""
  />
            </div>
        </section>;
};
export default Reviews;
